import React from 'react'
import { TextField, Button, Container,InputAdornment ,IconButton } from '@mui/material';
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import { Grid } from '@mui/material';
// import {styled} from '@mui/system'
import config from '../../../next.config.js'
// import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'
import axios from 'axios'
import Validator from "../../helpers/validator";
// import { printLogs } from '../../helpers/helpers';
import Visibilityoff from '@mui/icons-material/VisibilityOff'
import Visibility from '@mui/icons-material/Visibility'
import {useRouter} from 'next/router'
import {loginHandler} from '../Login/LoginHome'
import AlertDialog from '../../components/Dialogs/AlertDialog'
import getIncludeStatusIds from '../../../components/helpers/global/getIncludeStatusIds'
import {Customebtn , CustomeForm} from '../StyledComponent/Login.style'
import { useLocale } from '../../../context/language/language.provider';
function Change({codeCallBackData}) {
    const [loading, setLoading] = React.useState(false)
    const router=useRouter()
    const {changeLanguage} = useLocale();

    
    const { t,i18n } = useTranslation("common")
    const [responseMessgae,setResponseMessage]=React.useState({type:null,message:null,show:false})
    const [response,setResponse]=React.useState("")
    const [code, setCode] = React.useState("");
    const [inputList, setInputList] = React.useState(
      {
        mobile: codeCallBackData.mobile,
        code: "",
        newPassword:"",
        confirmNewPassword:"",
        index: 0,
        errorArray: [
          { mobile: false, message:  t("mandatory-field") },
          { code: false, message: t("mandatory-field") },
          { newPassword: false, message: [] },
          {confirmNewPassword:false,message: t("mandatory-field")}
        ]
      }
    );
    const handleInputChange = e => {
      const { name, value } = e.target;
      const list = { ...inputList };
      list[name] = value;
  
      handleError(list, name);
      setInputList(list);
    };
  
    const [hasError, setHasError] = React.useState(false)
    const [identicalPassword, setIdenticalPassword] = React.useState(false);

    let validatorObj = new Validator();
    const handleError = (varInput, name) => {
      let formIsValid = true;
      if(name=="newPassword"){
        if (varInput.newPassword != "") {
     
          if (
            varInput.newPassword ==
            varInput.confirmNewPassword
          ) {
            varInput.errorArray[3].confirmNewPassword = false;
            setIdenticalPassword(true);
          } else if(varInput.confirmNewPassword!="") {
            formIsValid = false;
            varInput.errorArray[3].confirmNewPassword = true;
            varInput.errorArray[3].message =
            t("passwordMatch");
              setIdenticalPassword(false);
          }
           else{
          varInput.errorArray[3].confirmPassword = false;
          }
          if(passValidList.length>0){
            let validate=validatorObj.validatePassword(varInput.newPassword,
                passValidList[0].max,
                passValidList[0].min,
                passValidList[0].validatePasswordType
                .filter(i => i.term.code == "number").length > 0,
                passValidList[0].validatePasswordType.filter(i => i.term.code == "upper-case").length > 0,
                passValidList[0].validatePasswordType.filter(i => i.term.code == "lower-case").length >0,
                passValidList[0].validatePasswordType.filter(i => i.term.code == "symboles").length>0
              )
   
              varInput.errorArray[2].message = validate.filter(i => i.error == true||i.visiblity==true);
              if (validate.filter(i => i.error == true).length > 0) {
                formIsValid = false;
                varInput.errorArray[2].newPassword =validate.filter(i => i.error == true).length > 0;
              } 
              else {
                varInput.errorArray[2].newPassword= false;
              }
            }
            else{
              varInput.errorArray[2].newPassword = false; 
            }
        }
         else {
          varInput.errorArray[2].newPassword = true;
          varInput.errorArray[2].message = [
            {
              type: "empty",
              message: t("mandatory-field"),
              error: true,
              visiblity: true,
            },
          ];
        }
        setHasError(formIsValid);
        return formIsValid;
     
      }
      if(name=="confirmNewPassword"){
        if (varInput.confirmNewPassword != "" && name == "confirmNewPassword") {
          if (varInput.newPassword ==varInput.confirmNewPassword) {
            varInput.errorArray[3].confirmNewPassword = false
            setIdenticalPassword(true)
    
           
          }
          else {
            setIdenticalPassword(false);
            formIsValid = false
            varInput.errorArray[3].confirmNewPassword = true
            varInput.errorArray[3].message =  t("passwordMatch");
          }
        }
        else{
          varInput.errorArray[3].confirmNewPassword = true
          // setHasError(true)
          formIsValid = false
        }
        setHasError(formIsValid)
        return formIsValid
      }
    };
    const handleSubmit = event => {
      event.preventDefault();
      setLoading(true)
      if(handleError(inputList,"confirmNewPassword")&&handleError(inputList,"newPassword")){
          axios
            .post(
              `${config["basePath"]}/api/user/forceChangePassword`,
              {
                data: {
                  username: codeCallBackData.mobile,
                  password: codeCallBackData.tempPassword,
                  newPassword: inputList.newPassword
                }
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  "accept-language":router.locale
                }
              }
            )
            .then( response => {
                // console.log("res0===============>",response,codeCallBackData)
              setLoading(false)
              setResponse(response.data.data)
  
            
              if (response.data.data.success == true) {
                responseMessgae["show"]=true 
                responseMessgae["type"]="success"
                responseMessgae["message"]=t("changePasswordSuccess")
                setResponseMessage({...responseMessgae})
              //   loginHandler(codeCallBackData.mobile,inputList.newPassword,router,changeLanguage,i18n).then(res=>{
              //     // console.log("res0===============>",res)
              //   if(Object.keys(res).length>0){
              //     responseMessgae["show"]=true 
              //     responseMessgae["type"]="success"
              //     responseMessgae["message"]=t("changePasswordSuccess")
              //     responseMessgae.langCode=res.langCode
              //     setResponseMessage({...responseMessgae})
               
              //   }
              //   else{
              //     responseMessgae["show"]=true 
              //     responseMessgae["type"]="error"
              //     responseMessgae["message"]=res
              //     setResponseMessage({...responseMessgae})
              
              //   }
              //  })
              }
           
           
              else{
                responseMessgae["show"]=true 
                responseMessgae["type"]="error"
                responseMessgae["message"]=response.data.data.subErrors[0].message
                setResponseMessage({...responseMessgae})
              }

            })
            .catch(err => (err));
 
          }else{
            handleError(inputList,"confirmNewPassword")
            handleError(inputList,"newPassword")
            setInputList({...inputList})
            setLoading(false)
          }
    };
    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const handleClickShowPassword = () => {
      setShowPassword(!showPassword);
    };
    const handleClickShowConfirmPassword = () => {
      setShowConfirmPassword(!showConfirmPassword);
    };
    const [passValidList,setPassValidList]=React.useState([])
    React.useEffect(() => {
      var configReqPassword = {
        method: 'post',
        url: config.basePath + '/api/globals/terms/get',
        headers: {
            'Content-Type': 'application/json'
        },
        data: { vocabCode: ["password-types"] }
    };
    getIncludeStatusIds().then(res=>{
      axios(configReqPassword).then(responsePassword => {
        let pass = responsePassword.data.data.filter(item => item.code == "password")
        var configReqPasswordValidate = {
            method: 'post',
            url: config.basePath + '/api/user/validatePasswordType/getValidatePolicy',
            headers: {
                'Content-Type': 'application/json'
            },
            data: { passwordTypeId: [pass[0].id],statusId:res}
        };
        axios(configReqPasswordValidate)
            .then(responsePasswordValidate => {
              
                let passwordValidateList = responsePasswordValidate.data.data.data
                setPassValidList(passwordValidateList)
            })
            .catch(error => {
              return error
   
            });
    })
    .catch(function (error) {
        return error
    });
  }).catch(err=>(err))
    }, []);
    return (
        <div className={style.SectionContainer }>
            <div className={style.allcard}>
                <div className={style.cardLogin}>
{/* // {printLogs("codeCallBackData=========>",codeCallBackData)} */}
                    <div className={style.card1}>
                        <form onSubmit={handleSubmit}>
                            <div className={style.card3}>
                                <div className={style.HeaderLogin} > {t("ForgetPassWord")} </div>
                        {/*         <p className={style.EnterEmail} >{t("EntertheCode")}</p> */}

                                <br />





                                <Grid container spacing={2} style={{paddingBottom: '10px',margin:0,width:"100%" }}>

                                    {/* <Grid className="griditem" item lg={12} xl={12} sm={12} md={12} xs={12} sx={{ paddingBottom: '10px' }} >
                                        <CustomeForm
                                     
                                            label={t("oldpassword")}
                                            id="oldpassword"
                                            name="oldpassword"
                                            className="textfield"
                                            variant="outlined"
                                     

                                        />
                                    </Grid> */}
                                    <Grid className="griditem" item lg={12} xl={12} sm={12} md={12} xs={12} sx={{ paddingBottom: '10px' }} >
                                        <CustomeForm
                                            sx={{ "&.MuiOutlinedInput-root.Mui-disabled": { "& > fieldset": { boder: 'none' } } }}
                                           
                                            className="textfield"
                                            label={t("Newpassword")}
                                            id="newPassword"
                                            name="newPassword"
                                            size="medium"
                                            error={inputList.errorArray[2].newPassword}
                                            type={showPassword?"string":"password"}
                                            onChange={e => handleInputChange(e)}
                                       
                                            helperText={inputList.errorArray[2].newPassword ? 
                                              Array.isArray((inputList.errorArray[2].message)) ?  inputList.errorArray[2].message.map(
                                                  ( i ,index)=><li style={{color:i.error?"#f12a59":"#038a88"}} key={index}>{i.message}</li>
                                                 ):inputList.errorArray[2].message
                                              
                                              : null}
                                            InputProps={{
                                              endAdornment: (
                                                  <InputAdornment position="start">
                                                      <IconButton
                                                          aria-label="toggle password visibilty"
                                                          onClick={handleClickShowPassword}
                                                          // onMouseDown={handleMouseDownPassword}
                                                          edge="start"
                                                      >
                                                          {showPassword?  <Visibility />:<Visibilityoff />}
                                                      </IconButton>
                                                  </InputAdornment>
                                              ),
                                          }}

                                        />

                                    </Grid>
                                    <Grid className="griditem" item lg={12} xl={12} sm={12} md={12} xs={12} sx={{ paddingBottom: '10px' }} >
                                        <CustomeForm
                                            sx={{ "&.MuiOutlinedInput-root.Mui-disabled": { "& > fieldset": { boder: 'none' } } }}
                                           
                                            className="textfield"
                                            label={t("confirmpassword")}
                                            id="confirmpassword"
                                            name="confirmNewPassword"
                                            size="medium"
                                            error={inputList.errorArray[3].confirmNewPassword}
                                            type={showConfirmPassword?"string":"password"}
                                            onChange={e => handleInputChange(e)}
                                    
                                            helperText={
                                              inputList.errorArray[3].confirmNewPassword
                                                ? inputList.errorArray[3].message
                                                : null
                                            }
                                            InputProps={{
                                              endAdornment: (
                                                  <InputAdornment position="start">
                                                      <IconButton
                                                          aria-label="toggle password visibilty"
                                                          onClick={handleClickShowConfirmPassword}
                                                          // onMouseDown={handleMouseDownPassword}
                                                          edge="start"
                                                      >
                                                          {showConfirmPassword?  <Visibility />:<Visibilityoff />}
                                                      </IconButton>
                                                  </InputAdornment>
                                              ),
                                          }}

                                        />

                                    </Grid>





                                    <Grid className="griditem" item lg={12} xl={12} sm={12} md={12} xs={12} style={{
                                    }}>
                                        <Stack direction="row" spacing={2}>
                                            <Customebtn  loadingPosition="start" loading={loading}
                                            
                                            type={"submit"}
                                            sx={{ color: "white" }} variant="outlined">
                                                {t("Send")}
                                            </Customebtn>

                                        </Stack>
                                    </Grid>



                                </Grid>
                            </div>

                        </form>
                    </div>
                    <div className={style.card1}>
                        <img className={style.loginimg} src={`${config.basePath}/assest/Group 6032.svg`} />
                    </div>
                </div>
            </div>
            <AlertDialog open={responseMessgae.show} text={responseMessgae.message}
                         type={responseMessgae.type}
                         btnOk={()=>{responseMessgae["show"]=false,setResponseMessage({...responseMessgae})
                        if(responseMessgae.type=="success"){
                          loginHandler(codeCallBackData.mobile,inputList.newPassword,router).then(res=>{
                            // console.log("res0===============>",res)
                          if(Object.keys(res).length>0){
                            changeLanguage(res.langCode)
                            router.push({pathname:"/"},"/",{locale:res.langCode})
                         
                          }
                          else{
                            responseMessgae["show"]=true 
                            responseMessgae["type"]="error"
                            responseMessgae["message"]=res
                            setResponseMessage({...responseMessgae})
                        
                          }
                         })                        }
                      
                        }}
                         />
        </div>
    )
}

export default Change

